<script setup>

import VideoModal from "@admin_ui/Pages/Devices/VideoModal";
import Confirmation from "@common/Confirmation";
import { TrashIcon, EyeIcon } from '@heroicons/vue/solid'
import {reactive, ref} from "vue"
import {Inertia} from "@inertiajs/inertia";

const props = defineProps({
  device : Object,
  recordings : Array,
})

const showVideoModal = ref(false)
const selectedVideo = ref();

const showRecording = (recording)=>{
  selectedVideo.value = recording
  showVideoModal.value = true
}

const deleteVideo = (recording) => {
  selectedVideo.value = recording
  showConfirmation.value = true
}

const showConfirmation = ref(false)

const deleteItem = (deleteAction) => {
  if(deleteAction === true){
    Inertia.delete(route('admin.devices.delete.recording',{'id' : selectedVideo.value.id , 'device': props.device.id }))
  }
  showConfirmation.value = false
}
</script>

<template>
  <div>
    <confirmation
      v-if="showConfirmation"
      @onDelete="deleteItem"
      message="Weet je zeker dat je deze opname wenst te verwijderen?"
    />
    <video-modal v-if="showVideoModal" :video="selectedVideo" @closeModal="showVideoModal=false"/>
    <div class="max-w-10xl mx-auto">
      <div class="w-full px-4 pt-4 pb-5 sm:flex sm:items-center sm:justify-between">
        <h3 class="text-lg font-medium leading-6 text-gray-900">Recordings</h3>
      </div>
      <div class="flex flex-col">
        <div class="overflow-x-auto shadow-md sm:rounded-lg">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden ">
              <table class="min-w-full divide-y divide-gray-200 table-fixed ">
                <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                     <span class="inline-flex w-full justify-between cursor-pointer">
                      ID
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    opgenomen op
                  </th>
                  <th>

                  </th>
                </tr>
                </thead>
                <tbody v-if="recordings" class="bg-white divide-y divide-gray-200  ">
                <tr v-for="(recording , index ) in recordings" :key="recording.id" class="hover:bg-gray-100 align-center" :class="index % 2 === 0 ? undefined : 'bg-gray-50'">
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">{{ recording.id }}</td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">{{ recording.created_at }}</td>
                  <td class="flex justify-end py-4 px-6 gap-2">
                      <button
                        @click="showRecording(recording)"
                        class="text-danger "
                        title="watch video"
                      >
                        <EyeIcon class="action-icons items-center"/>
                      </button>
                      <button
                        @click="deleteVideo(recording)"
                        class="text-danger items-center"
                        title="delete video"
                      >
                        <TrashIcon class="action-icons ms-4 text-red-500 items-center"/>
                      </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="recordings.length < 1" class="bg-white divide-y ">
              <p class="text-center text-sm py-4">
                Er zijn momenteel geen opnames om weer te geven.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.action-icons{
  width: 20px;
  height: 20px;
  display: inline-block;
}
</style>
